﻿window.cGestionDateNuite = function(bddRef) {

    this.isTarifNuitWeekEnd = function (dat) {
        return this.isNuitWeekEnd(dat) || this.isNuitFerie(dat) || this.isNuitPont(dat)
    }
    this.isTarifNuitVacances = function (dat) {
        return this.isNuitVacancesScolaires(dat)
    }
    this.isTarifNuitWeekEndVacances = function (dat) {
        return this.isNuitVacancesScolaires(dat) && (this.isNuitWeekEnd(dat) || this.isNuitFerie(dat) || this.isNuitPont(dat))
    }

    //retourne si le jour du lendemain est férié
    this.isNuitFerie = function (dat) {
        return parametre.joursFeries.getIsDateFerie((new Date(dat)).addDays(1)) != null
    }

    //retourne si le jour du lendemain est en période de vacances scolaires
    this.isNuitVacancesScolaires = function (dat) {
        return parametre.vacances.getLstVacance((new Date(dat)).addDays(1)).length > 0
    }

    //retourne si le lendemain est un Samedi ou un dimanche
    //ou si la nuit est férié
    this.isNuitWeekEnd = function (dat) {
        if (dat.dayOfWeekName() == "Ve" || dat.dayOfWeekName() == "Sa") { return true }
        else { return false }
    }

    this.isNuitPont = function (dat) {
        if (!this.isNuitFerie(dat)) {
            if (dat.dayOfWeekName() == "Di" && (this.isNuitFerie((new Date(dat)).addDays(1))) || this.isNuitFerie((new Date(dat)).addDays(2))) {
                //pour qu'un dimanche soit une nuit de pont, il faut que le mardi ou le mercredi soit férié (et donc lundi ou mardi nuit férié)
                return true
            } else if (dat.dayOfWeekName() == "Lu" && this.isNuitFerie((new Date(dat)).addDays(1))) {
                //pour qu'un lundi soit une nuit de pont, il faut que le mercredi soit férié (et donc mardi nuit férié)
                return true
            } else if (dat.dayOfWeekName() == "Me" && this.isNuitFerie((new Date(dat)).addDays(-1))) {
                //un mercredi est une nuit de pont si le mercredi est férié (et donc nuité de la veille férié)
                return true
            } else if (dat.dayOfWeekName() == "Je" && (this.isNuitFerie((new Date(dat)).addDays(-1)) || this.isNuitFerie((new Date(dat)).addDays(-2)))) {
                //un jeudi est une nuit de pont si la veille ou l'avant veille est une nuité férié
                return true
            } else {return false}
        }
        return false
    }

}
window.gestionDateNuite = new cGestionDateNuite()